/**
 * Network failure helpers (Phase 16C, design §6.7). Moved here from the Phase 9B draft queue.
 */
import { ApiError, ApiErrorCode, isApiError } from '../../dtos/common/api.dto';

/** Shown on laptops and on phones without offline mode when a write can't reach the server. */
export const RECONNECT_MESSAGE = 'You\'re offline — reconnect to continue.';

/** True for errors that mean "the request never reached the server" (status 0, or a timeout). */
export function isOfflineError(error: unknown): boolean {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return true;
  if (isApiError(error)) return error.code === ApiErrorCode.NETWORK_ERROR || error.code === ApiErrorCode.TIMEOUT || error.statusCode === 0;
  return error instanceof TypeError;
}

/** The error a write throws when it can't be sent and this device can't queue it. */
export function reconnectError(): ApiError {
  return new ApiError(RECONNECT_MESSAGE, ApiErrorCode.NETWORK_ERROR, 0);
}

/** Platform kill switch (16D D8): packets and registration answer 403 OFFLINE_DISABLED; sync keeps working. */
export const OFFLINE_DISABLED_MESSAGE = 'Offline mode is temporarily unavailable. Work already on this device still syncs.';

export function isOfflineDisabledError(error: unknown): boolean {
  return isApiError(error) && error.statusCode === 403 && error.domainCode === 'OFFLINE_DISABLED';
}

export function isOnline(): boolean {
  return typeof navigator === 'undefined' || navigator.onLine !== false;
}
